const defaultCurrentConfigurationTabIndex = 0

const state = {
  currentConfigurationTabIndex: defaultCurrentConfigurationTabIndex
}

const getters = {}

const mutations = {
  SET_CURRENTCONFIGURATIONTABINDEX: (state, payload) => {
    state.currentConfigurationTabIndex = payload
  }
}

const actions = {
  setCurrentConfigurationTabIndex({ commit }, currentTabIndex) {
    commit('SET_CURRENTCONFIGURATIONTABINDEX', currentTabIndex)
  },
  clearCurrentConfigurationTabIndex({ commit }) {
    const defCurrentConfigurationTabIndex = 0
    commit('SET_CURRENTCONFIGURATIONTABINDEX', defCurrentConfigurationTabIndex)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
